import { Rating } from "react-simple-star-rating";
import React, { useState } from "react";
import SwitchSelector from "react-switch-selector";
import * as S from "../styles";

function StarAvaliacao({ corrida, status, questoes, avaliarCorrida }) {
  const [resposta, setResposta] = useState({});
  const [star, setStar] = useState(0);

  const renderQuestoes = (questao, index) => {
    switch (questao.tipo) {
      case "bool":
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {questao.txt}
            <SwitchSelector
              onChange={(e) => {
                saveQuestao(questao, e, index);
              }}
              options={[
                {
                  label: <div style={{ padding: 15 }}>Sim</div>,
                  value: true,
                  selectedBackgroundColor: "#06b20c",
                },
                {
                  label: <div style={{ padding: 15 }}>Não</div>,
                  value: false,
                  selectedBackgroundColor: "#fb3131",
                },
              ]}
              initialSelectedIndex={0}
              backgroundColor={"#353b48"}
              fontColor={"#f5f6fa"}
            />
          </div>
        );
      case "int":
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {questao.txt}
            <Rating
              initialValue={0}
              onClick={(e) => {
                saveQuestao(questao, e, index);
              }}
            />
          </div>
        );
        default:
          return (<></>)
    }
  };
  const saveQuestao = (questao, valor, index) => {
    let r = resposta;
    r[questao.id] = valor;
    setResposta(r);
  };

  return (<>
    {(questoes.length > 0) ?? <S.DetailLargeBox>
      {" "}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>Avaliação</div>
        <Rating
          initialValue={0}
          onClick={(e) => {
            setStar(e);
          }}
        />
        {questoes.map((questao, index) => renderQuestoes(questao, index))}
      </div>
      <button
        style={{
          padding: "8px",
          textAlign: "center",
          background: "#f28643d3",
          border: "1px solid #000",
          borderRadius: "4px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          cursor: "pointer",
          margin: "4px",
          fontSize: "16px",
          fontWeight: "bold",
        }}
        onClick={() => {
          avaliarCorrida(resposta, star);
        }}>
        Avaliar Corrida
      </button>
    </S.DetailLargeBox>}</>
  );
}
export default StarAvaliacao;
